import { render, staticRenderFns } from "./absenceCourse.vue?vue&type=template&id=6aecd281&scoped=true&"
import script from "./absenceCourse.vue?vue&type=script&lang=js&"
export * from "./absenceCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aecd281",
  null
  
)

export default component.exports